import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { SectionMenu, SectionMenuItem } from 'uikit/layout'
import Banners from './Banners'
import { BlackList } from './BlackList'
import { DeactivationModules } from './DeactivationModules'
import { Faq } from './Faq'
import { Settings } from './Settings'
import { ClientId } from './ClientId'

export const Services = () => {
  const match = useRouteMatch()

  if (match.isExact && match.path === '/services') {
    return <Redirect to="/services/banners" />
  }

  return (
    <>
      <SectionMenu>
        <SectionMenuItem colorPalette="teal" to="/services/banners">
          Баннеры
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/services/settings">
          Настройки
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/services/deactivation-modules">
          Деактивация модулей
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/services/black-list">
          Черный список
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/services/faq">
          FAQ
        </SectionMenuItem>
        <SectionMenuItem colorPalette="teal" to="/services/clientId">
          ClientId СКБ
        </SectionMenuItem>
      </SectionMenu>
      <Switch>
        <Route path={`${match.url}/banners`}>
          <Banners />
        </Route>
        <Route path={`${match.url}/settings`}>
          <Settings />
        </Route>
        <Route path={`${match.url}/deactivation-modules`}>
          <DeactivationModules />
        </Route>
        <Route path={`${match.url}/black-list`}>
          <BlackList />
        </Route>
        <Route path={`${match.url}/faq`}>
          <Faq />
        </Route>
        <Route path={`${match.url}/clientId`}>
          <ClientId />
        </Route>
      </Switch>
    </>
  )
}
